import React from 'react';
import clsx from 'clsx';
import MuiListItemText from '@material-ui/core/ListItemText';
import { LIST_ITEM_TEXT } from 'ctsutheme/core';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => ({
  noTextSecondary: {
    color: 'inherit',
    '& .MuiTypography-colorTextSecondary': {
     color: 'inherit'
    }
  }
}));

const ListItemText = ({
  className, category, subcategory, subcategoryPrimary, flex, ...props
}) =>{
  const classes = useStyles();
 
  return (
    <MuiListItemText
      className={clsx(
        LIST_ITEM_TEXT.root,
        className,
        category && LIST_ITEM_TEXT.category,
        subcategory && LIST_ITEM_TEXT.subcategory,
        subcategoryPrimary && LIST_ITEM_TEXT.subcategoryPrimary,
        flex && LIST_ITEM_TEXT.flex
      )}
      classes={{
        primary: LIST_ITEM_TEXT.primary,
        secondary: clsx(LIST_ITEM_TEXT.secondary, classes.noTextSecondary)
        
      }}
      {...props}
    />
  );
} 

export default ListItemText;